import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../utils/parseError.js';

const deleteTour = async ({ state, tourId, userId, removeTour, Toast, updateState, refreshPage }) => {
  const { itemDetails } = state;
  const { resourceName, start_time } = itemDetails;
  const date = moment(start_time).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Tour Deleted', description: `For ${resourceName} on ${date}`};
  try {
   await removeTour(tourId, userId);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeTour',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Deleting Tour Failed",
        description: `For [${resourceName} on ${date}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default deleteTour;
